import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    ctaButton: 'Let’s go!',
    description: {
      mandatee:
        'We need to collect specific information about the company in order to submit your application.',
      nonMandatee: {
        withFirstname:
          'We need to collect specific information about your company in order to submit your application.', // No firstname in english is intended (tone of voice)
        withoutFirstname:
          'We need to collect specific information about your company in order to submit your application.',
      },
    },
    title: {
      mandatee: 'Capital deposit',
      nonMandatee: 'Deposit your capital',
    },
    warning: {
      mandatee:
        'All information entered must be identical to that written in the draft statutes.',
      nonMandatee:
        'All information entered must be identical to that written in your draft statutes.',
    },
  },
  fr: {
    ctaButton: 'C’est parti\u00A0!',
    description: {
      mandatee:
        'Nous avons besoin de collecter des informations relatives à l’entreprise afin de pouvoir déposer votre dossier.',
      nonMandatee: {
        withFirstname:
          '{firstName}, nous avons besoin de collecter des informations relatives à votre entreprise afin de pouvoir déposer votre dossier.',
        withoutFirstname:
          'Nous avons besoin de collecter des informations relatives à votre entreprise afin de pouvoir déposer votre dossier.',
      },
    },
    title: {
      mandatee: 'Dépôt de capital',
      nonMandatee: 'Déposer votre capital',
    },
    warning: {
      mandatee:
        'Ces informations doivent correspondre exactement à celles qui figurent dans le projet de statuts de la société.',
      nonMandatee:
        'Ces informations doivent correspondre exactement à celles qui figurent dans le projet de statuts de votre société.',
    },
  },
} as const);
